import React, {
  Dispatch,
  SetStateAction,
  useRef,
  useState,
  FormEvent,
  useMemo,
  useCallback,
  useEffect,
} from "react";
import styles from "./inviteView.module.scss";
import Button from "../../../../components/button/Button";
import { CellValue, Workbook } from "exceljs";
import Select from "../../../../components/select/Select";
import { UserRoleEnum, SelectOption } from "../../../../types";
import { cleanRichText, isRichText } from "../../../../utils/helpers";
import {
  TextInput,
  TextInputValue,
} from "@src/components/text-input/TextInput";
import {
  SchoolUsersDocument,
  useInviteUserAsEducatorMutation,
} from "@src/api/graphql-codegen";
import {
  isEmptyObject,
  validateEmail,
  validateIsEmpty,
} from "../../../../utils/validation";
import { useToast, useRolesPermissions, useUser } from "@src/hooks";
import { useHistory, useLocation } from "react-router-dom";
import Checkbox from "@components/checkbox/Checkbox";
import { Popover } from "antd";
import IconOutline from "src/assets/icons/new-outline-info.svg?react";
import { logger } from "../../../../utils/logger";

const header = [
  "Role",
  "First Name",
  "Last Name",
  "Email",
  "Account",
  "School",
];
const headerSchools = ["Schools"];

const list = [[]];
let blob;

const emptyErrors = {
  firstName: "",
  lastName: "",
  email: "",
  school: "",
  adminUser: "",
  distSchool: "",
};

type ErrorFields = Partial<Record<keyof typeof emptyErrors, string>>;

let generateExcel = () => {
  let workbook = new Workbook();
  let worksheet = workbook.addWorksheet("OP Bulk Upload");

  const header = ["First Name", "Last Name", "Email"];
  worksheet.mergeCells("A1:C1");
  worksheet.mergeCells("A2:C2");
  let row1 = worksheet.getCell("A1");
  row1.value = "Open Parachute Bulk User Uploader";
  row1.font = {
    size: 20,
  };

  let row2 = worksheet.getCell("A2");
  row2.value =
    "Please fill in First Name, Surname and Email address of all teachers you wish to invite Note: All fields required.";

  let headerRow = worksheet.addRow(header);

  headerRow.eachCell((cell, number) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFB073" },
      bgColor: { argb: "FFB073" },
    };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  for (let i = 1; i <= 3; i++) worksheet.getColumn(i).width = 40;

  // Generate Excel File with given name
  workbook.xlsx.writeBuffer().then((data) => {
    let link = document.createElement("a");
    link.download = "OP-Bulk-User-Uploader.xlsx";
    blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    link.href = URL.createObjectURL(blob);
    link.click();
  });
};

let generateExcelWithHead = (
  list: any[],
  header: any[],
  accountOptions: any[],
  account: string,
  schoolOptions: any[],
  school: string,
) => {
  let workbook = new Workbook();

  let worksheet = workbook.addWorksheet("OP Bulk Upload");
  let schools = workbook.addWorksheet("Schools");
  schools.state = "veryHidden";
  let accountList = workbook.addWorksheet("AccountList");
  accountList.state = "veryHidden";
  accountList.addRow([account]);

  worksheet.mergeCells("A1:H1");
  worksheet.mergeCells("A2:H2");

  let row1 = worksheet.getCell("A1");
  row1.value = "Open Parachute Bulk User Uploader";
  row1.font = {
    size: 20,
  };

  let row2 = worksheet.getCell("A2");
  row2.value =
    "Please use the dropdowns for Role and School. You will not be able to do not do bulk uploads for multiple Accounts on the same Bulk Upload.";

  let headerRow = worksheet.addRow(header);
  schools.addRow(headerSchools);

  headerRow.eachCell((cell, number) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFB073" },
      bgColor: { argb: "FFB073" },
    };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  for (let i = 1; i <= 7; i++) worksheet.getColumn(i).width = 28;

  schoolOptions.map((tem) => [tem.label]).forEach((d) => schools.addRow(d));

  // @ts-ignore
  worksheet.dataValidations.model["A4:A9999"] = {
    allowBlank: true,
    error: "Please use the drop down to select a valid value",
    errorTitle: "Invalid Selection",
    formulae: ['"Educator,Admin"'],
    showErrorMessage: true,
    type: "list",
  };
  // @ts-ignore
  worksheet.dataValidations.model["G4:G9999"] = {
    allowBlank: true,
    error: "Please use the drop down to select a valid value",
    errorTitle: "Invalid Selection",
    formulae: ['"Yes,No"'],
    showErrorMessage: true,
    type: "list",
  };

  // @ts-ignore
  worksheet.dataValidations.model["F4:F9999"] = {
    allowBlank: false,
    error: "Please use the drop down to select a valid value",
    errorTitle: "Invalid Selection",
    formulae: ["Schools!$A$2:$A$9999"],
    showErrorMessage: true,
    type: "list",
  };

  // @ts-ignore
  worksheet.dataValidations.model["E4:E9999"] = {
    allowBlank: false,
    error: "Please use the drop down to select a valid value",
    errorTitle: "Invalid Selection",
    formulae: ["AccountList!$A$1:$A$1"],
    showErrorMessage: true,
    type: "list",
  };

  for (let v = 4; v <= 9999; v++) {
    let cellRole = worksheet.getCell(`A${v}`);
    let cellAccount = worksheet.getCell(`E${v}`);
    let cellSchool = worksheet.getCell(`F${v}`);
    cellAccount.value = account;
    cellRole.value = "Educator";
    if (school.length > 0) cellSchool.value = school;
  }

  // Generate Excel File with given name
  workbook.xlsx.writeBuffer().then((data) => {
    let link = document.createElement("a");
    link.download = "OP-Bulk-User-Uploader.xlsx";
    blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    link.href = URL.createObjectURL(blob);
    link.click();
  });
};

type Props = {
  setJsonParse: Dispatch<SetStateAction<any[]>>;
  accountOptions: any;
  schools: SelectOption[];
  closeSlide: () => void;
};

export function InviteView(props: Props) {
  const fileUploader = useRef(null);
  const { setJsonParse, schools, closeSlide, accountOptions } = props;
  const [school, setSchool] = useState("");
  const [bulkSchool, setBulkSchool] = useState("");
  const [distSchool, setDistSchool] = useState("");
  const [customer, setCustomer] = useState("");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [error, setError] = useState<ErrorFields>(emptyErrors);
  const [beError, setBeError] = useState("");
  const [schoolOptions, setSchoolOptions] = useState<SelectOption[]>([]);

  const { successToast } = useToast();
  const [me] = useUser();

  const history = useHistory();
  const { pathname } = useLocation();

  const isDistrictAdmin = useRolesPermissions([UserRoleEnum.DistrictAdmin]);

  useEffect(() => {
    if (isDistrictAdmin && me) {
      const allowedSchoolIds = me?.districtSchools
        ? JSON.parse(me?.districtSchools)
        : [];
      const allowedSchoolsOptions = (schools ?? [])
        .filter((s) => !!s?.value && allowedSchoolIds.includes(s.value))
        .map((s) => {
          return {
            value: s!.value,
            label: s!.label,
          };
        });
      setSchoolOptions(allowedSchoolsOptions);
    }
  }, [schools, isDistrictAdmin, me]);

  useEffect(() => {
    if (me?.customer) {
      setCustomer(me.customer.id);
    }
  }, [me]);

  const [createInvite, { loading }] = useInviteUserAsEducatorMutation({
    onError(e) {
      setBeError(e.message);
    },
    update(cache, response) {
      const u = response.data?.inviteUserAsEducator;
      if (u) {
        successToast(
          `Your Invitation has been successfully sent to ${response.data?.inviteUserAsEducator?.firstName} ${response.data?.inviteUserAsEducator?.lastName}!`,
        );
        cache.updateQuery(
          {
            query: SchoolUsersDocument,
          },
          (data) => ({
            schoolUsers: [u, ...(data?.schoolUsers || [])],
          }),
        );
      }
      clearFields();
      closeSlide();
    },
  });

  const clearFields = () => {
    setFirstName("");
    setLastName("");
    setEmail("");

    setBeError("");
    setError(emptyErrors);
  };

  const handleChangeText =
    (setter: Dispatch<SetStateAction<string>>, key: keyof typeof emptyErrors) =>
    (value: TextInputValue) => {
      setter(value as string);
      setError({
        ...error,
        [key]: "",
      });
    };

  const handleChangeOption =
    (setter: Dispatch<SetStateAction<string>>, key: keyof typeof emptyErrors) =>
    (value) => {
      setter(value.value);
      setError({
        ...error,
        [key]: "",
      });
    };

  const validate = () => {
    const errors: ErrorFields = {};

    if (validateEmail(email)) {
      errors.email = validateEmail(email);
    }

    if (validateIsEmpty(firstName)) {
      errors.firstName = "First name must not be empty.";
    }

    if (validateIsEmpty(lastName)) {
      errors.lastName = "Last name must not be empty.";
    }

    if (isDistrictAdmin && validateIsEmpty(school)) {
      errors.school = "School must not be empty for School Admin.";
    }

    return errors;
  };
  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    const errors = validate();
    if (isEmptyObject(errors)) {
      setError(emptyErrors);
      setBeError("");
      if (isDistrictAdmin) {
        createInvite({
          variables: {
            input: {
              firstName,
              lastName,
              email,
              school,
              adminId: me?.id,
            },
          },
        });
      } else {
        createInvite({
          variables: {
            input: {
              firstName,
              lastName,
              email,
              adminId: me?.id,
            },
          },
        });
      }
    } else {
      setError(errors);
    }
  };

  const handleUpdateInvite = () => {
    const errors = validate();

    if (isEmptyObject(errors)) {
      setError(emptyErrors);
      setBeError("");
      if (isDistrictAdmin) {
        createInvite({
          variables: {
            input: {
              firstName,
              lastName,
              email,
              school,
              adminId: me?.id,
              admin: isAdmin,
            },
          },
        });
      } else {
        createInvite({
          variables: {
            input: {
              firstName,
              lastName,
              email,
              adminId: me?.id,
              admin: isAdmin,
            },
          },
        });
      }
    } else {
      setError(errors);
    }
  };

  const handleInputChange = (e: any) => {
    if (e.target.files.length > 0) {
      let f = e.target.files[0];
      const reader = new FileReader();
      reader.onload = async (evt) => {
        // evt = on_file_select event
        /* Parse data */
        if (evt && evt.target) {
          // ------------------------
          const buffer = reader.result;
          const wbe = new Workbook();
          await wbe.xlsx.load(buffer as ArrayBuffer).then((workbook) => {
            let updatedDataOne: any[] = [];
            let updatedDataIndexOne = 0;

            try {
              workbook.eachSheet((sheet, id) => {
                if (sheet?.name === "OP Bulk Upload")
                  sheet.eachRow((row, rowIndex) => {
                    let valv:
                      | CellValue[]
                      | { [p: string | number]: CellValue }
                      | any[] = row.values;

                    if (isDistrictAdmin) {
                      if (rowIndex > 3 && (valv[2] || valv[3] || valv[4])) {
                        if (isRichText(valv[2]))
                          valv[2] = cleanRichText(valv[2]);

                        if (isRichText(valv[3]))
                          valv[3] = cleanRichText(valv[3]);

                        if (isRichText(valv[4]))
                          valv[4] = cleanRichText(valv[4]);

                        let rowData = {
                          role: valv[1] || "",
                          firstName: valv[2] || "",
                          lastName: valv[3] || "",
                          id: updatedDataIndexOne,
                          email:
                            typeof valv[4] === "string" &&
                            valv[4].trim().length > 0
                              ? valv[4].trim()
                              : valv[4]?.text
                                ? valv[4].text.trim()
                                : "",
                          invite: "Yes",
                          account: valv[5],
                          school:
                            typeof valv[6] === "string"
                              ? valv[6].trim()
                              : valv[6],
                        };
                        updatedDataIndexOne++;
                        updatedDataOne.push(rowData);
                      }
                    } else {
                      if (rowIndex > 3 && (valv[1] || valv[2] || valv[3])) {
                        if (isRichText(valv[1]))
                          valv[1] = cleanRichText(valv[1]);

                        if (isRichText(valv[2]))
                          valv[2] = cleanRichText(valv[2]);

                        if (isRichText(valv[3]))
                          valv[3] = cleanRichText(valv[3]);

                        let rowData = {
                          firstName: valv[1] || "",
                          lastName: valv[2] || "",
                          id: updatedDataIndexOne,
                          email:
                            typeof valv[3] === "string" &&
                            valv[3].trim().length > 0
                              ? valv[3].trim()
                              : valv[3]?.text
                                ? valv[3].text.trim()
                                : "",
                          invite: "Yes",
                        };
                        updatedDataIndexOne++;
                        updatedDataOne.push(rowData);
                      }
                    }
                  });
                setJsonParse(updatedDataOne);
              });
            } catch (e) {
              logger.info(e);
            }
          });
        }
      };
      reader.readAsBinaryString(f);
    }
  };

  const handleCopyLink = useCallback(async () => {
    if (me?.schools) {
      await navigator.clipboard.writeText(
        `${window.location.protocol}//${window.location.host}/registration?id=${me?.schools?.[0]?.id}&entity=sch`,
      );
      successToast("Registration Link Copied!");
    }
  }, [successToast, me]);

  const copySchoolLink = useCallback(async () => {
    await navigator.clipboard.writeText(
      `${window.location.protocol}//${window.location.host}/registration?id=${distSchool}&entity=sch`,
    );
    successToast("School Registration Link Copied!");
  }, [successToast, distSchool]);

  const isLoading = loading;
  const enableInvite = useMemo(() => {
    if (email !== "" && firstName !== "" && lastName !== "") {
      return true;
    }
    return false;
  }, [email, firstName, lastName]);

  const accountSelected = customer.length > 0;

  const handleChangeAdmin = useCallback((v: boolean) => {
    setIsAdmin(v);
  }, []);

  const content = (
    <div className={styles.cardBack}>
      <IconOutline className={styles.infoicon} width={44} height={44} />
      <div className={styles.hoverCardText}>
        <div className={styles.span1}>
          Account Administrators can manage all users from their school. This
          includes inviting staff, removing staff, and viewing staff usage.
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className={styles.container}>
        <div className={styles.gridItem}>
          <div className={styles.subTitle}>Registration Link</div>
          <div className={styles.regularText}>
            Send this link to your staff to register an account. Manage all
            registrations in the &nbsp;
            <a
              className={styles.userManageLink}
              href="/"
              onClick={(e) => {
                e.preventDefault();
                if (pathname.includes("/admin/users")) {
                  closeSlide();
                } else {
                  history.replace("/admin/users");
                }
              }}
            >
              Manage Users
            </a>{" "}
            page.
          </div>
          {isDistrictAdmin ? (
            <>
              <div className={styles.regularText}>
                Generate a unique link for each school in your District.
              </div>
              <Select
                error={!!error.school}
                subTitle={error.school}
                disabled={schoolOptions.length === 0}
                label={"School"}
                options={schoolOptions}
                value={distSchool}
                onChange={handleChangeOption(setDistSchool, "distSchool")}
                searchAutoFocus
              />

              <Button
                disabled={distSchool.length === 0}
                label="School Registration Link"
                size="small"
                className={styles.schoolLinkButton}
                onClick={copySchoolLink}
              />
              <div className={styles.noteText}>
                <strong>Note.</strong> Don't see a school in this list? Send us
                a message to add it!
              </div>
              <div className={styles.regularText}>
                Alternatively, send this District Registration link to all
                staff, who can select their school upon registration.
              </div>
              <Button
                label="District Registration Link"
                size="small"
                className={styles.copyLinkButton}
                onClick={handleCopyLink}
              />
              <div className={styles.noteText}>
                <strong>Note.</strong> Schools must be added to your District
                first before using this link.
              </div>
            </>
          ) : (
            <Button
              label="Copy Registration Link"
              size="small"
              className={styles.copyLinkButton}
              onClick={handleCopyLink}
            />
          )}
        </div>
        <div className={styles.gridItem}>
          <div className={styles.subTitle}>{"Send an Email Invite"}</div>
          <div className={styles.normalText}>
            {
              "Send staff an email inviting them to register an account. This option will send weekly reminder emails if they have not accepted their invite."
            }
          </div>
          <form onSubmit={handleSubmit}>
            <div className={styles.content}>
              <TextInput
                allowSpecialCharacters
                hasError={!!error.firstName}
                subTitle={error.firstName}
                placeholder={"First Name"}
                label={"First name"}
                id={"firstName"}
                value={firstName}
                onChange={handleChangeText(setFirstName, "firstName")}
              />
              <TextInput
                allowSpecialCharacters
                hasError={!!error.lastName}
                subTitle={error.lastName}
                placeholder={"Last Name"}
                label={"Last name"}
                id={"lastName"}
                value={lastName}
                onChange={handleChangeText(setLastName, "lastName")}
              />
              <TextInput
                allowSpecialCharacters
                hasError={!!error.email}
                subTitle={error.email}
                placeholder={"Email"}
                label={"Email"}
                id={"email"}
                value={email}
                onChange={handleChangeText(setEmail, "email")}
              />
              <Checkbox
                id={"isAdmin"}
                checked={isAdmin}
                onChange={handleChangeAdmin}
              >
                <div className={styles.checkboxLabel}>
                  Account Administrator
                  <Popover
                    overlayClassName="custom-info"
                    placement="bottom"
                    content={content}
                  >
                    <IconOutline
                      className={styles.labelInfoIcon}
                      width={24}
                      height={24}
                    />
                  </Popover>
                </div>
              </Checkbox>
              {isDistrictAdmin && (
                <Select
                  error={!!error.school}
                  subTitle={error.school}
                  disabled={schoolOptions.length === 0}
                  label={"School"}
                  options={schoolOptions}
                  value={school}
                  onChange={handleChangeOption(setSchool, "school")}
                  searchAutoFocus
                />
              )}

              {Boolean(beError) && (
                <div className={styles.error}>{beError}</div>
              )}
              <div className={styles.action}>
                <Button
                  disabled={isLoading || !enableInvite}
                  type={"button"}
                  className={styles.inviteButton}
                  label={"Invite User"}
                  onClick={handleUpdateInvite}
                />
              </div>
            </div>
          </form>
        </div>
        <div className={styles.gridItem}>
          <div className={styles.subTitle}>Bulk Email Invite</div>
          <div className={styles.normalText}>
            Upload an Excel file to bulk enroll staff to your account. All staff
            will receive an email inviting them to register an account.
          </div>
          <div className={styles.normalText}>
            <strong>Note. You must use the Excel Template below.</strong>
          </div>
          {isDistrictAdmin && (
            <>
              <h3 className={styles.bulkInviteSubTitle}>
                Step 1: Download Excel Template
              </h3>
              <div>
                <Select
                  label={
                    "(Optional) Select a specific school to upload users to."
                  }
                  options={schoolOptions}
                  searchAutoFocus
                  value={bulkSchool}
                  onChange={(e) => setBulkSchool(e.value)}
                />
              </div>
            </>
          )}
          <div
            style={{ marginBottom: 20, marginTop: isDistrictAdmin ? 20 : 0 }}
          >
            {isDistrictAdmin && (
              <div className={styles.downloadText}>
                Download the Excel Template file:
              </div>
            )}
            <a
              title={"Download"}
              className={styles.downloadLink}
              href="/"
              onClick={(e) => {
                e.preventDefault();
                if (isDistrictAdmin) {
                  if (!accountSelected) {
                    window.alert(
                      "Please select an account to do a bulk upload for first!",
                    );
                  } else if (schoolOptions.length === 0) {
                    window.alert("There are no schools for this account!");
                  } else {
                    let a = accountOptions.filter(
                      (obj: any) => obj.value === customer,
                    );
                    let s = schoolOptions.filter(
                      (obj: any) => obj.value === bulkSchool,
                    );
                    if (a.length > 0)
                      generateExcelWithHead(
                        list,
                        header,
                        accountOptions,
                        a.length > 0 ? a[0].label : "",
                        schoolOptions,
                        s.length > 0 ? s[0].label : "",
                      );
                  }
                } else {
                  generateExcel();
                }
              }}
              download
            >
              {isDistrictAdmin
                ? "Click to download"
                : "Download Excel Template"}
            </a>
          </div>
          {isDistrictAdmin && (
            <h3 className={styles.bulkInviteSubTitle}>
              Step 2: Add Staff to Excel Template
            </h3>
          )}
          {isDistrictAdmin && (
            <h3 className={styles.bulkInviteSubTitle}>
              Step 3: Upload Excel File
            </h3>
          )}
          <div className={styles.parentRow}>
            <div className={styles.uploader}>
              <input
                ref={fileUploader}
                onChange={(e) => handleInputChange(e)}
                type="file"
                className={styles.fileInput}
                accept=".csv, .xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
              <div className={styles.uploadDiv}>
                <Button
                  label={"Upload Completed Template"}
                  color={"orange"}
                  size="small"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    // @ts-ignore
                    fileUploader?.current?.click();
                  }}
                  outline={true}
                  className={styles.inputButton}
                />
                <div className={styles.smallText}>
                  or drag & drop completed template here
                </div>
              </div>
            </div>
          </div>
          <div className={styles.action}>
            <Button
              disabled={false}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                // @ts-ignore
                fileUploader?.current?.click();
              }}
              label={"UPLOAD USERS"}
            />
          </div>
        </div>
      </div>
    </>
  );
}
